import { AnimatePresence, motion } from "framer-motion";

export default function Loader({ done }) {
  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="intro-loader"
          className="fixed inset-0 z-[90] flex flex-col items-center justify-center bg-[#0B0C10]"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="overflow-hidden">
            <motion.span
              className="font-display block text-3xl font-bold uppercase tracking-[0.35em] text-[#F4F6FB] md:text-5xl"
              initial={{ y: "115%" }}
              animate={{ y: 0 }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
            >
              Elentara
            </motion.span>
          </div>
          <div className="mt-8 h-px w-48 overflow-hidden bg-white/10">
            <motion.div
              className="h-full w-full origin-left bg-gradient-to-r from-[#8B5CF6] via-[#06B6D4] to-[#D4AF37]"
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 1.3, ease: [0.65, 0, 0.35, 1], delay: 0.3 }}
            />
          </div>
          <motion.p
            className="mt-6 font-mono text-[10px] uppercase tracking-[0.4em] text-[#06B6D4]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            Initializing Experience
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
